/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/01/2024
 */

import * as React from 'react';
import TeachingActivities from '@/wpt-lib/pdf/TeachingActivities';
import ResearchActivities from '@/wpt-lib/pdf/ResearchActivities';
import ServiceActivities from '@/wpt-lib/pdf/ServiceActivities';
import useData from '@/wpt-lib/pdf/useData';
import { WorkplanCommentSection } from '@/wpt-lib/interfaces/WorkplanComment';
import Page from '@/wpt-lib/pdf/common/Page';
import SectionComments from '@/wpt-lib/pdf/SectionComments';

const Activities = () => {
    const comments = useData().comments.filter((c) => c.section === WorkplanCommentSection.ACTIVITY);
    return (
        <>
            <TeachingActivities />
            <ResearchActivities />
            <ServiceActivities />
            {comments.length > 0 && (
                <Page>
                    <SectionComments heading="Activity Comments" comments={comments} />
                </Page>
            )}
        </>
    );
};

export default Activities;
